import styled from 'styled-components'
import Spinner from 'components/Shared/Spinner/Index'

const StyledSpinner = styled(Spinner)`
  width: 16px;
  margin-left: 6px;
`

const LoadingIndicator = () => {
  return (
    <StyledSpinner />
  )
}

export default LoadingIndicator
